import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import safeHtml from "../../utils/safeHtml";
import fetchJsonWithFallback from "../../utils/fetchJsonWithFallback";
import { CDN_INCLUDES, CDN_ASSETS, EQUAL_HOUSING_LOGO } from "../../utils/cdn";
import localNavigation from "../../data/navigation.json";
import "./index.css";

function Footer() {
  const [navigation, setNavigation] = useState(localNavigation);

  useEffect(() => {
    let isMounted = true;
    fetchJsonWithFallback(CDN_INCLUDES + "navigation.json", localNavigation).then((data) => {
      if (isMounted) setNavigation(data);
    });
    return () => {
      isMounted = false;
    };
  }, []);

  const { footer } = navigation;
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <Container className="px-0">
          <p className="site-footer__disclaimer">{safeHtml(footer.disclaimer)}</p>

          <div className="site-footer__columns">
          <div className="site-footer__brand">
            {isHome ? (
              <img alt="Marco Management, LLC" src={CDN_ASSETS + "logo-mark.webp"} />
            ) : (
              <Link to="/">
                <img alt="Marco Management, LLC" src={CDN_ASSETS + "logo-mark.webp"} />
              </Link>
            )}
          </div>

          <div>
            <div className="site-footer__links">
              {footer.links.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className=""
                >
                  {safeHtml(link.label)}
                </Link>
              ))}
            </div>
          </div>

          <div className="site-footer__contact">
            <div className="site-footer__contact-item">
              <FaEnvelope />
              <a href={`mailto:${footer.contact.email}`}>{footer.contact.email}</a>
            </div>
            <div className="site-footer__contact-item">
              <FaPhoneAlt />
              <a href={`tel:${footer.contact.phoneTel}`}>{footer.contact.phone}</a>
            </div>
            <div className="site-footer__contact-item">
              <FaPhoneAlt />
              <span>{footer.contact.phoneSpanish}</span>
            </div>
            <div className="site-footer__contact-item">
              <FaMapMarkerAlt />
              <a href={footer.contact.mapUrl} target="_blank" rel="noreferrer">
                {footer.contact.address}
              </a>
            </div>
          </div>

          <div className="site-footer__badge">
            <a target="_blank" rel="noopener noreferrer" href="https://www.hud.gov/fairhousing">
              <img src={EQUAL_HOUSING_LOGO} alt="Equal Housing Opportunity" />
            </a>
          </div>
          </div>
        </Container>
      </div>
    </footer>
  );
}

export default Footer;
